import { render, staticRenderFns } from "./PCNAPriceBreakdown.vue?vue&type=template&id=9af9d070&scoped=true"
import script from "./PCNAPriceBreakdown.vue?vue&type=script&lang=js"
export * from "./PCNAPriceBreakdown.vue?vue&type=script&lang=js"
import style0 from "./PCNAPriceBreakdown.vue?vue&type=style&index=0&id=9af9d070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af9d070",
  null
  
)

export default component.exports